export default __webpack_public_path__ + "static/media/hyderabad.bf6d068f.png";